import { useEffect, useState } from "react";
import { api } from "./api.js";

// Активація й продовження доступу (server/src/modules/activation.js): токен від адміністратора на місяць чи рік або
// оплата тарифу карткою — після підтвердження банком доступ відкривається (продовжується) сам. Повернення зі сторінки оплати — сюди ж (#/activate): перечитуємо стан.
const uah = (n) => new Intl.NumberFormat("uk-UA").format(n);
const ua = (iso) => iso.split("-").reverse().join(".");

export default function Activate({ user, onActivated }) {
  const [st, setSt] = useState(null), [token, setToken] = useState(""), [err, setErr] = useState(""), [busy, setBusy] = useState("");
  const load = () => api("/api/activation").then((r) => { setSt(r); if (r.activated && !user.activated) onActivated(); }, (e) => setErr(e.message));
  useEffect(() => { load(); }, []);
  // Оплата щойно пройшла — банк підтверджує за кілька секунд: перевіряємо ще кілька разів
  useEffect(() => {
    if (!st?.pending || st.activated) return;
    const t = setTimeout(load, 4000);
    return () => clearTimeout(t);
  }, [st]);

  const redeem = async (e) => {
    e.preventDefault(); setErr(""); setBusy("token");
    try { await api("/api/activation/redeem", { method: "POST", body: { token } }); setToken(""); onActivated(); if (!user.activated) location.hash = "#/"; else load(); }
    catch (x) { setErr(x.message); } finally { setBusy(""); }
  };
  const pay = async (plan) => {
    setErr(""); setBusy(plan);
    try { location.href = (await api("/api/activation/pay", { method: "POST", body: { plan } })).pageUrl; }
    catch (x) { setErr(x.message); setBusy(""); }
  };

  // Активний — продовження; строк минув — так і кажемо; ще не активований — активація
  const active = user.activated || st?.activated, until = st?.until || user.activatedUntil;
  if (active && !until) return (
    <section className="add-only first-co">
      <div className="first-co-head"><h1>Доступ без обмеження строку</h1><p>Можна підключати компанії й працювати.</p></div>
      <a className="btn" href="#/">До компаній</a>
    </section>
  );
  return (
    <section className="add-only first-co activate">
      <div className="first-co-head">
        <h1>{active ? "Продовжіть доступ" : until ? "Строк доступу минув" : "Активуйте акаунт"}</h1>
        <p>{active ? `Доступ діє до ${ua(until)}. Токен або оплата продовжать його на місяць чи рік.`
          : until ? `Доступ діяв до ${ua(until)}. Введіть новий токен або оплатіть тариф — доступ відновиться одразу.`
          : "Введіть токен активації або оплатіть тариф — доступ відкриється одразу."}</p>
      </div>
      <form className="card activate-card" onSubmit={redeem}>
        <label className="field">Токен активації
          <input value={token} onChange={(e) => setToken(e.target.value)} placeholder="EC-XXXX-XXXX-XXXX-XXXX" autoComplete="off" spellCheck="false"
            autoCapitalize="characters" required maxLength={64} aria-describedby="act-hint" />
          <span className="field-hint" id="act-hint">Токен надсилає адміністратор eCabinet — наприклад, після оплати за рахунком</span>
        </label>
        <button className="btn btn-block" disabled={!token.trim() || Boolean(busy)}>{busy === "token" ? "Перевіряємо…" : active ? "Продовжити" : "Активувати"}</button>
        <p className="activate-or" aria-hidden="true"><span>або оплатіть карткою</span></p>
        {st && (
          <div className="activate-plans">
            {[["month", "Місяць", st.price, "грн / місяць"], ["year", "Рік", st.priceYear, "грн / рік"]].map(([plan, name, sum, per]) => sum ? (
              <button key={plan} type="button" className="activate-plan" disabled={!st.card || Boolean(busy)} onClick={() => pay(plan)}>
                <span className="muted small">{name}</span><b>{uah(sum)}</b><span className="muted small">{per}</span>
                {busy === plan && <span className="small" role="status">Відкриваємо оплату…</span>}
              </button>) : null)}
          </div>
        )}
        {st && !st.card && <p className="muted small activate-note">Оплату карткою ще не підключено — отримайте токен у адміністратора.</p>}
        {st?.pending > 0 && <p className="notice small activate-note" role="status">Чекаємо підтвердження оплати від банку…</p>}
        {err && <p className="error small" role="alert">{err}</p>}
      </form>
      {!active && <p className="muted small first-co-note">Токен — на місяць або на рік; цей строк зараховується й першій компанії, яку ви підключите.</p>}
      {active && <a className="link-btn" href="#/">← До компаній</a>}
    </section>
  );
}
